import type {UseQueryOptions} from '@tanstack/react-query'
import {keepPreviousData, queryOptions, useQuery} from '@tanstack/react-query'

import type {SupportedLocales} from '@/lib/locale/locale'
import type {Order} from '@/models/orderModel'
import {getOrder} from '@/services/orderService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export function getOrderQueryKey(params: {orderId: string; locale: SupportedLocales}) {
  return ['order', params.orderId, params.locale] as const
}

export function getOrderQueryOptions<TData = Order | false, TError = Error>(
  params: {
    orderId: string
    locale: SupportedLocales
  },
  options?: Omit<UseQueryOptions<Order | false, TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getOrderQueryKey(params),
    queryFn: async ({signal}) => getOrder({orderId: params.orderId, locale: params.locale, signal}),
    placeholderData: keepPreviousData,
    ...NO_REFETCH_OPTIONS,
    ...options,
  })
}

export default function useOrder(orderId: string, locale: SupportedLocales) {
  return useQuery(
    getOrderQueryOptions({
      orderId,
      locale,
    }),
  )
}
